import React from "react";

import Dashboard from "../Dashboard";
import Schedule from "../Schedule";
import BookAppointment from "../Configuration/Modals/BookAppointmentContainer";
import CancelBooking from "../Configuration/Modals/CancelBookingContainer";
import DeleteAppointment from "../Configuration/Modals/DeleteAppointmentContainer";
import DeleteTimeSlot from "../Configuration/Modals/DeleteTimeSlotContainer";

const Day = () => {
  return (
    <Dashboard>
      <Schedule timeIntervalSize="15" additionalClassName="day" />
      <BookAppointment />
      <CancelBooking />
      <DeleteAppointment />
      <DeleteTimeSlot />
    </Dashboard>
  );
};

export default Day;
